import { connect } from 'react-redux';
import { getTopProductsData, getTopProductsTotal } from '../selectors';
import PieChartWithLegend from '../../components/PieChartWithLegend';
import { t } from '../../../../../modules/infra/i18n';

const TopSalesByProduct = connect(state => ({
  title: t('reports:leaderboard.top_sales_by_product_top_5'),
  data: getTopProductsData(state),
  total: getTopProductsTotal(state),
  automationId: 'topSalesByProduct',
}))(PieChartWithLegend);

export default TopSalesByProduct;
